import React, { useEffect, useState } from "react";
import { UsersInnerOptions } from "../UsersInnerOptions";
import { useQuery } from "react-query";
import { getClientMembers } from "hooks/api/Users/getClientMembers";
import { useErrorHandler } from "Exceptions/ErrorHandler";
import { SettingLayout } from "layouts/SettingLayout";
import { useColumns } from "./columns";
import { DataTable } from "components/ui/DataTable";
import { ClientMember } from "contracts/ClientMember";

const ListClientMember = () => {
  const { options } = UsersInnerOptions();
  const [localData, setLocalData] = useState<ClientMember[]>([]);
  const { errorHandler } = useErrorHandler();
  const { columns } = useColumns();
  const { data, isLoading } = useQuery({
    queryKey: "clientMembers",
    queryFn: getClientMembers,
    onError: errorHandler,
  });

  useEffect(() => {
    if(data) {
        setLocalData(data);
    }
    return () => {
        setLocalData([]);
    };
}, [data]);
  return (
    <SettingLayout options={options}>
      <DataTable
        isLoading={isLoading}
        data={localData ?? []}
        filterBy={'Nome'}
        columns={columns}
        showControlColumns={false}
      />
    </SettingLayout>
  );
};

export default ListClientMember;
